export default __webpack_public_path__ + "static/media/moo.d021aaae.jpg";